import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OffersService } from '../../../../shared/services/pubServices/offers.service';
import { Offer, OfferStatus } from '../../../../models/pubModel/offer.model';

@Component({
  selector: 'pub-campdetails-component',
  templateUrl: './offer-details-component.html',
  styleUrls: ['./offer-details-component.scss']
})

export class offerDetailsComponent implements OnInit {
  offer = new Offer();
  status = new OfferStatus();

  constructor(private route: ActivatedRoute,
              private router: Router,
              private toastrService: ToastrService,
              private offersService: OffersService) {
  }

  ngOnInit() {
    this.getOffer(this.route.snapshot.params?.['id']);
   }

   getOffer(id: string): void {
    this.offersService.getOffer(id)
    .subscribe(
     data => {
      this.offer.offerId = data.data.offerId;
      this.offer.offerName = data.data.offerName;
      this.offer.countryid = data.data.country.id;
      this.offer.countryname = data.data.country.name;
      this.offer.countryalpha2Code = data.data.country.alpha2Code;
      this.offer.payout = data.data.payout;
      this.offer.offerTrackingLink = data.data.offerTrackingLink;
      this.offer.offerCategoryId = data.data.offerCategory.id;
      this.offer.offerCategoryname = data.data.offerCategory.name;
      this.offer.offerDevices = data.data.offerDevices;
      this.offer.offerGlobalStatus = data.data.status.globalStatus;
      this.offer.offerPublisherStatus = data.data.status.publisherStatus;
      this.offer.operatingSystems = data.data.operatingSystems;
    },
     error => {
       console.log(error);
     });
    }

    onStatus(){
      if(this.offer.offerPublisherStatus=='Active')
      {
        this.status.statusId=3; // disabled
        this.offer.offerPublisherStatus='Disabled';

        this.offersService.updateOfferStatus(this.offer.offerId, this.status)
        .subscribe(
         () => {
          this.toastrService.success('Publisher offer status is changed.', 'Success !');
        },
         error => {
           console.log(error);
         });

      }
      else
      {
        this.status.statusId=1; // active
        this.offer.offerPublisherStatus='Active';

        this.offersService.updateOfferStatus(this.offer.offerId, this.status)
        .subscribe(
         () => {
          this.toastrService.success('Publisher offer status is changed.', 'Success !');
        },
         error => {
           console.log(error);
         });
      }
    }

   onCancel(){
    this.router.navigate(['/pub/offers']);
  }
}
